const CHECK_NEW_COLLECT_ORDERS_SUCCESS = "CHECK_NEW_COLLECT_ORDERS_SUCCESS";
const CHECK_NEW_COLLECT_ORDERS = "CHECK_NEW_COLLECT_ORDERS";
const CHECK_NEW_COLLECT_ORDERS_REFRESH_TIME_STAMP =
  "CHECK_NEW_COLLECT_ORDERS_REFRESH_TIME_STAMP";
const CHECK_NEW_COLLECT_ORDERS_FAILURE = "CHECK_NEW_COLLECT_ORDERS_FAILURE";
const CLEAR_CHECK_NEW_COLLECT_ORDERS = "CLEAR_CHECK_NEW_COLLECT_ORDERS";
const CHECK_NEW_COLLECT_ORDERS_PENDING = "CHECK_NEW_COLLECT_ORDERS_PENDING";
const checkNewOrdersPendingSymbols = {
  CHECK_NEW_COLLECT_ORDERS_SUCCESS,
  CHECK_NEW_COLLECT_ORDERS_FAILURE,
  CHECK_NEW_COLLECT_ORDERS_PENDING,
  CHECK_NEW_COLLECT_ORDERS,
  CHECK_NEW_COLLECT_ORDERS_REFRESH_TIME_STAMP,
  CLEAR_CHECK_NEW_COLLECT_ORDERS,
};
export default checkNewOrdersPendingSymbols;
